import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_mock_lights_gallery';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/**
 * Dev-only virtual dashboard (`/dash/-106`) that injects fake lights + light
 * groups so widgets and Main tabs can be QA'd without hardware.
 * Off by default; enable from the Dev Modal so it does not sit in the dashboard tab rail.
 */
export const mockLightsGalleryEnabled = writable<boolean>(readInitialValue());

mockLightsGalleryEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isMockLightsGalleryEnabled = (): boolean => get(mockLightsGalleryEnabled);

export const setMockLightsGalleryEnabled = (enabled: boolean) => {
	mockLightsGalleryEnabled.set(enabled);
};
